<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content ">
      <myHeader></myHeader>
      <!-- <div class="searchBox">
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div> -->
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>模拟卷列表</p>
          <!-- <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加模拟卷</button>
          </div> -->
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p style="color:#FF7543;">
                <span @click="titleAdmin(item)">
                  大标题管理
                </span>
                <span @click="lookTopic(item)">
                  查看题库 
                </span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>


  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getExerModel,saveTest } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'题型'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      token:'',
      obj:{
        page:1,
        rows:10,
        mtid:'',
        qpid:''
      },
      totalPage:0,
      userData:{
        authority:[],
      },
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.obj.mtid = this.$route.query.mtid;
    this.obj.qpid = this.$route.query.qpid;
    this.getList();

    
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    getList(){
      var that = this;
      getExerModel(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    titleAdmin(e){
      this.$router.push('/title?mtid='+this.obj.mtid+'&qpid='+this.obj.qpid +'&model_id='+e.model_id+'&is_video='+e.is_video);
    },

    lookTopic(e){
      this.$router.push('/exercisesTopic?model_id='+e.model_id);
    }
  },

  
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 3 );
}



.noClick{
  background-color: #ccc!important;
}
</style>



// WEBPACK FOOTER //
// src/exam/exercises.vue